import { FC } from "react";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import ModuleSkeleton from "shared/components/ModuleSkeleton";
import { SideSkeleton, CenterSkeleton } from "./styled";

const TopWinnersSkeleton: FC = () => {
  return (
    <ModuleSkeleton>
      <SideSkeleton />
      <FlexColumn gap={2}>
        <CenterSkeleton />
        <CenterSkeleton />
        <CenterSkeleton />
      </FlexColumn>
      <SideSkeleton />
    </ModuleSkeleton>
  );
};

export default TopWinnersSkeleton;
